import { GetPartnerResponse } from "../../services/partner";
import { ENV } from "@vrf/fr-vrf-core";
import {
  InDefCommonFlagType,
  PtnrType,
} from "../../util/general-code/enums/general-codes";
import { ChnType, PartnerInfo } from "./PartnerDetailPageState";

export const ADD_TYPE_INIT_INFO: PartnerInfo = {
  ptnrId: "",
  ptnrCd: "",
  ptnrName: "",
  ptnrNameWtngChng: "",
  ptnrTypeCd: PtnrType.OTHERS,
  ptnrTypeName: "",
  buCnTypeCd: "",
  buCnTypeName: "",
  buCd: "",
  cnCd: "",
  dipByRgn: "",
  cpntId: "",
  delFlg: "",
  updtDtimePtnr: "",
  chnTypeList: [],
};

export const TEMPLATE_FILE_URL =
  "spreadsheet-template/partner-detail-page.xlsx";

export const REQUEST_CD_TYPES = {
  FILE_TYPE_TYPE: "file_type_type",
  CHN_TYPE_TYPE: "chn_type_type",
  PTNR_BU_CNTRY_TYPE: "ptnr_bu_cntry_type",
  PTNR_TYPE: "ptnr_type",
  IN_DEF_COMMON_FLAG_TYPE: "in_def_common_flag_type",
};

export const requestCdTypes = Object.values(REQUEST_CD_TYPES);

export enum PartnerDetailMode {
  MODIFY = "mod",
  ADD = "add",
}

export const createPartnerInfo = (res: GetPartnerResponse | undefined) => {
  if (res == null) {
    return ADD_TYPE_INIT_INFO;
  }
  const chnTypeList: ChnType[] = res.chnTypeList.map((e) => ({
    ...e,
    addRowFlg: InDefCommonFlagType.NO,
  }));
  const ptnrInfo: PartnerInfo = {
    ...res,
    chnTypeList: chnTypeList,
  };
  return ptnrInfo;
};
